export default __webpack_public_path__ + "static/5_37-1b3ab67865c1021036bd5343f8de0a34.png";